import CommonTextInput from "@/components/inputs/CommonTextInput"
import { Logo } from "@/components/Logo"
import LottieAnimation from "@/components/LottieAnimation"
import { NavigationButtonsFake } from "@/components/NavigationButtonsFake"
import { getFirebaseClientAuth } from "@/lib/firebase-client-config"
import { ConfigSlim } from "@/types/configuration"
import { performConsent, performRecaptcha, performRegistration } from "@/utils/client/client_api"
import { validateEmail, validatePassword, validateTaxCode } from "@/utils/functions"
import { createUserWithEmailAndPassword, sendEmailVerification, signInAnonymously, signInWithEmailAndPassword } from "firebase/auth"
import emailLoad from "@/assets/images/loaders/emailLoad.json";
import React, { ReactElement, useEffect, useState } from "react"
import { ConsentItem } from "@/types/typesInterfaces"
import PrivacyComponent from "./privacy_component"
import { ROUTE_HOME } from "@/navigation"
import useAnimatedRouter from "@/hooks/useAnimatedRouter"

interface Props {
    texts: any;
    locale: string
    configInfo: ConfigSlim;
    goToLogin: () => void;
    tenantMessageElement?: ReactElement
}

enum PageView {
    REGISTRATION,
    EMAIL_PENDING,
}

const WithAuthRegistrationComponent = ({ locale, texts, configInfo, goToLogin }: Props) => {

    const [consentStates, setConsentStates] = useState<ConsentItem[]>([]);
    const [consentsCatalogue, setConsentsCatalogue] = useState<any>();
    const [pageView, setPageView] = useState(PageView.REGISTRATION)

    const [name, setName] = useState<string | number>('');
    const [surname, setSurname] = useState<string | number>('');
    const [taxCode, setTaxCode] = useState<string | number>('');
    const [emailInput, setEmailInput] = useState<string | number>('');
    const [password, setPassword] = useState<string | number>('');
    const [password2, setPassword2] = useState<string | number>('');

    // const { executeRecaptcha } = useReCaptcha();
    const [csrfToken, setCsrfToken] = useState<string | undefined>(undefined);

    const { animatedRoute } = useAnimatedRouter();


    useEffect(() => {
        getConsents()
    }, [])

    const handleConsentChange = (index) => {
        const temp = [...consentStates]
        temp[index].accepted = !temp[index].accepted;
        setConsentStates(temp);
    };

    const getConsents = async () => {
        try {
            const firebaseClientAuth = await getFirebaseClientAuth();
            if (!firebaseClientAuth) {
                throw new Error('firebaseClientAuth is null');
            }

            const anonymousUserCredentials = await signInAnonymously(firebaseClientAuth);

            if (anonymousUserCredentials.user) {
                const anonymousToken = await anonymousUserCredentials.user.getIdToken();

                const responseConsent = await performConsent(locale, anonymousToken);
                if (responseConsent.isOk) {
                    const fetchedConsents = responseConsent.response;
                    setConsentsCatalogue(fetchedConsents);
                    setConsentStates(
                        fetchedConsents.map((c) => ({
                            consentCode: c.consentCode,
                            category: c.category,
                            answerType: c.answerType,
                            flagAccMandatory: c.flagAccMandatory,
                            flagMandatory: c.flagMandatory,
                            accepted: false,
                            startValidityDate: c.startValidityDate,
                            title: c.consentContent[0].title

                        }))
                    );
                } else {
                    console.error(responseConsent);
                }
            }
        } catch (error) {
            console.error("Error during performConsent", error);
        }
    }

    const checkConsentUserChoiches = () => {
        return consentStates.every((consent) => {
            if (consent.flagMandatory) {
                return consent.accepted === true;
            }
            return true;
        });
    }


    const handleValidationForRegistration = () => {
        if (!!name &&
            !!surname &&
            !!taxCode &&
            validateTaxCode(String(taxCode), String(name), String(surname)) &&
            !!emailInput &&
            validateEmail(String(emailInput)) &&
            !!password &&
            !!password2 &&
            password === password2 &&
            validatePassword(String(password)) &&
            checkConsentUserChoiches()
        ) {
            return true
        } else {
            return false
        }
    }

    const [timer, setTimer] = React.useState<any>();

    const checkEmailVerified = async () => {

        const firebaseClientAuth = await getFirebaseClientAuth();
        if (!firebaseClientAuth) {
            throw new Error('firebaseClientAuth is null');
        }
        if (firebaseClientAuth.currentUser?.emailVerified) {
            if (timer) {
                clearInterval(timer)
                setTimer(undefined)
            }
            animatedRoute(ROUTE_HOME)
        }
    };

    const handleRegistration = async () => {
        const recaptchaToken = "";
        // const recaptchaToken = await executeRecaptcha("login");
        // const res = await performRecaptcha(recaptchaToken)
        // if (!res.isOk) {
        //     console.error("Error during login", "no recptcha valid");
        // }

        try {
            console.log('handleRegistration');

            const emailString = String(emailInput).trim();
            const passwordString = String(password).trim();

            const firebaseClientAuth = await getFirebaseClientAuth();
            if (!firebaseClientAuth) {
                throw new Error('firebaseClientAuth is null');
            }

            const userCredentials = await createUserWithEmailAndPassword(firebaseClientAuth, emailString, passwordString);
            if (userCredentials.user) {

                console.log('userCredentials.user');
                const token = await userCredentials.user.getIdToken();

                const responseBff = await performRegistration(String(name), String(surname), String(taxCode), String(emailInput), String(password), consentStates, token);

                if (responseBff.isOk) {

                    await sendEmailVerification(userCredentials.user);
                    setPageView(PageView.EMAIL_PENDING)
                } else {
                    console.log("BFF broken...");
                }
            }
        } catch (error) {
            console.error("Error during login", error);
        }
    }

    const handleRegistrationClick = () => {
        const isValid = handleValidationForRegistration();
        if (!isValid) {
            return;
        }
        // If valid, proceed
        handleRegistration();
    }

    const renderForm = () => {
        return (
            <div className="mt-10 lg:mt-0 lg:mb-20 lg:h-full">
                <form className="grid grid-cols-12 lg:gap-20">
                    <div className="col-span-12 lg:col-span-6  ">
                        <h2 className="my-10">
                            Effettua la <span className="font-fraunces text-orangeH3">REGISTRAZIONE</span>
                        </h2>
                        <div className="mb-5">
                            <CommonTextInput
                                type='text'
                                labelText={'Nome'}
                                autoComplete="given-name"
                                isMandatory={true}
                                minLength={2}
                                maxLength={30}
                                inputText={name}
                                setInputText={setName}
                            />
                        </div>
                        <div className="mb-5">
                            <CommonTextInput
                                type='text'
                                labelText={'Cognome'}
                                autoComplete="family-name"
                                isMandatory={true}
                                minLength={2}
                                maxLength={30}
                                inputText={surname}
                                setInputText={setSurname}
                            />
                        </div>
                        <div className="mb-5">
                            <CommonTextInput
                                type='text'
                                labelText={'Codice Fiscale'}
                                isMandatory={true}
                                minLength={2}
                                maxLength={30}
                                inputText={taxCode}
                                setInputText={setTaxCode}
                            />
                        </div>
                        <div className="mb-5">
                            <CommonTextInput
                                type='email'
                                labelText={'Email'}
                                autoComplete="email"
                                isMandatory={true}
                                inputText={emailInput}
                                setInputText={setEmailInput}
                            />
                        </div>

                        <div className="mb-3">
                            <CommonTextInput
                                type='password'
                                labelText={'Password'}
                                autoComplete="new-password"
                                isMandatory={true}
                                minLength={4}
                                maxLength={20}
                                inputText={password}
                                setInputText={setPassword}
                            />
                            <div className="mx-5 text-xs">Almeno 8 caratteri, 1 lettera maiuscola, 1 minuscola, 1 numero e 1 carattere speciale.</div>
                        </div>
                        <div >
                            <CommonTextInput
                                type='password'
                                labelText={'Conferma password'}
                                autoComplete="new-password"
                                isMandatory={true}
                                minLength={4}
                                maxLength={20}
                                inputText={password2}
                                setInputText={setPassword2}
                            />
                        </div>

                    </div>
                    <div className="col-span-12 lg:col-span-6  lg:flex lg:flex-col lg:justify-between">
                        <Logo alignment="left" />
                        <div className="mt-20">
                            <button className="text-center hover:cursor-pointer my-3" onClick={goToLogin} dangerouslySetInnerHTML={{ __html: texts.returnToLogin }}>

                            </button>
                            <div className="mb-20">
                                La registrazione nel percorso di orientamento Advisory di Habacus vale per tutti i prodotti digitali di Habacus.
                            </div>
                            <div className="hidden lg:block">
                                <PrivacyComponent
                                    texts={texts}
                                    consentsCatalogue={consentsCatalogue}
                                    consentStates={consentStates}
                                    handleConsentChange={handleConsentChange} />
                            </div>
                            <div className="mt-5">
                                <NavigationButtonsFake
                                    text={'Registrati'}
                                    stepIsValidated={
                                        handleValidationForRegistration()
                                    }
                                    onClick={handleRegistrationClick}
                                />
                                <div className="flex flex-col items-center">
                                    <small className="text-red-500">
                                        {!!taxCode && !validateTaxCode(String(taxCode), String(name), String(surname)) &&
                                            "Il codice fiscale non è valido."}
                                    </small>
                                    <small className="text-red-500">
                                        {!!emailInput && !validateEmail(String(emailInput)) &&
                                            "L&apos;email non è valida."}
                                    </small>
                                    <small className="text-red-500">
                                        {!!password && !!password2 && password !== password2 &&
                                            "La password non corrisponde a quella da confermare."}
                                    </small>
                                    <small className="text-red-500">
                                        {!!password && !!password2 && password === password2 && !validatePassword(String(password)) &&
                                            "La password deve contenere almeno 8 caratteri, inclusi maiuscole, minuscole, numeri e caratteri speciali."}
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        );
    }

    const renderEmailPending = () => {
        return (
            <div className="mt-10 lg:mt-0 lg:mb-20 lg:h-full">
                <div className="grid grid-cols-12 lg:gap-20">
                    <div className="col-span-12 lg:col-span-6">
                        <LottieAnimation animationData={emailLoad} height="100%" width="100%" minHeight="20vh" />
                    </div>
                    <div className="col-span-12 lg:col-span-6 flex flex-col justify-center items-start font-xl">
                        <div className="text-2xl my-10">
                            <span className="font-fraunces text-orangeH3 uppercase font-bold">Controlla</span> la tua casella mail
                        </div>
                        <div className="text-2xl mb-10">
                            <span className="font-fraunces text-orangeH3 uppercase font-bold">convalida</span> l&apos;indirizzo che hai usato per registrati
                        </div>
                        <div className="text-2xl ">
                            <span className="font-fraunces text-orangeH3 uppercase font-bold">torna</span> per iniziare il percorso con Habacus
                        </div>
                    </div>

                </div>
            </div>
        );
    }

    const render = () => {
        switch (pageView) {
            case PageView.REGISTRATION:
                if (timer === undefined) {
                    const timer = setInterval(checkEmailVerified, 3000);
                    setTimer(timer)
                }
                return renderForm();
            case PageView.EMAIL_PENDING:
                return renderEmailPending()
        }
    }

    return render();
}

export default WithAuthRegistrationComponent;